<script lang="ts">
	import { page } from "$app/stores";
	import { browser } from "$app/environment";
	import { getCurrentUser } from "../currentUser";
	import Visits from "./Visits.svelte";
	import GoogleAnalytics from "./GoogleAnalytics.svelte";
	import GoogleAds from "./GoogleAds.svelte";
	import FacebookPixel from "./FacebookPixel.svelte";
	import BingPixel from "./BingPixel.svelte";
	import RedditPixel from "./RedditPixel.svelte";
	import CustomerIOTracking from "./CustomerIOTracking.svelte";
	import LinkedInPixel from "./LinkedInPixel.svelte";
	import MicrosoftClarity from "./MicrosoftClarity.svelte";
	import PinterestPixel from "./PinterestPixel.svelte";
	import TikTokPixel from "./TikTokPixel.svelte";
	import LogRocket from "./LogRocket.svelte";
	import TwitterPixel from "./TwitterPixel.svelte";
	import SentryDevToolbar from "./SentryDevToolbar.svelte";
	import { addConsoleLogo } from "./SmoreDevConsoleLogo";

	const { isStaging, isDevelopment, showSentryToolbar, useClarity } = $page.data;

	const user = getCurrentUser();

	if (browser) {
		if (isStaging) {
			addConsoleLogo("staging");
		} else if (isDevelopment) {
			addConsoleLogo("development");
		}
	}
</script>

<svelte:head>
	{#if browser}
		<GoogleAnalytics />

		<!-- Do not deconstruct the "doNotTrack" property. Otherwise, it won't get updated!!! -->
		{#if !$page.data.doNotTrack}
			<Visits />

			<CustomerIOTracking {user} />

			{#if !isDevelopment}
				<LogRocket {user} />

				{#if useClarity}
					<MicrosoftClarity />
					<BingPixel />
				{/if}

				<GoogleAds />

				<FacebookPixel {user} />

				<PinterestPixel {user} />

				<RedditPixel />

				<TwitterPixel />

				<TikTokPixel />

				<LinkedInPixel />
			{/if}
		{/if}

		{#if showSentryToolbar}
			<SentryDevToolbar />
		{/if}
	{/if}
</svelte:head>
